import axios from 'axios';
import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { TDevice } from '@/features/devices/schemas/devices.schemas.ts';

export type TGetDeviceResponse = TDevice & {
  plantName: string;
  plantCountry: string;
  plantState: string;
  plantCity: string;
};

export async function getDevice({
  deviceId,
}: {
  deviceId: string;
}): Promise<TGetDeviceResponse | undefined | never> {
  try {
    const { data } = await client.get(`/devices/${deviceId}`);

    return data?.body;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(`${error?.response?.data?.message}`);
    }

    if (error instanceof Error) {
      throw new Error(`${error.message}}`);
    }
  }
}

export const useGetDeviceQuery = ({ deviceId }: { deviceId: string }) => {
  return useQuery({
    queryKey: ['devices', deviceId],
    queryFn: () => getDevice({ deviceId }),
    retry: 1,
  });
};
